import { t } from "@bookingcom/lingojs-core";
import { COMPANY_NAME } from "@flights/constants";
function getFaqData(i18n) {
    return [
        {
            question: i18n.trans(t("seo_flight_index_lp_faq", "1", "question", {
                variables: {
                    b_companyname: COMPANY_NAME
                }
            })),
            answer: i18n.trans(t("seo_flight_index_lp_faq", "1", "answer_1")),
            id: 1
        },
        {
            question: i18n.trans(t("seo_flight_index_lp_faq", "2", "question", {
                variables: {
                    b_companyname: COMPANY_NAME
                }
            })),
            answer: i18n.trans(t("seo_flight_index_lp_faq", "2", "answer_1")),
            id: 2
        },
        {
            question: i18n.trans(t("seo_flight_index_lp_faq", "3", "question")),
            answer: i18n.trans(t("seo_flight_index_lp_faq", "3", "answer_1")),
            id: 3
        },
        {
            question: i18n.trans(t("seo_flight_index_lp_faq", "4", "question")),
            answer: i18n.trans(t("seo_flight_index_lp_faq", "4", "answer_1")),
            id: 4
        },
        {
            question: i18n.trans(t("seo_flight_index_lp_faq", "5", "question")),
            answer: i18n.trans(t("seo_flight_index_lp_faq", "5", "answer_1")),
            id: 5
        },
        {
            question: i18n.trans(t("seo_flight_index_lp_faq", "6", "question", {
                variables: {
                    b_companyname: COMPANY_NAME
                }
            })),
            answer: i18n.trans(t("seo_flight_index_lp_faq", "6", "answer_1")),
            id: 6
        }
    ];
}
export { getFaqData };
